import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatChipGrid, MatChipInput, MatChipRemove, MatChipRow } from '@angular/material/chips'
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete'
import { FormsModule } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/input'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-selection',
  standalone: true,
  imports: [
    MatIcon,
    MatChipRow,
    MatChipInput,
    MatAutocomplete,
    MatOption,
    FormsModule,
    MatAutocompleteTrigger,
    MatChipGrid,
    MatChipRemove,
    MatLabel,
    MatFormField,
    TranslatePipe,
    TranslateDirective,
  ],
  templateUrl: './selection.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './selection.component.scss',
})
export class SelectionComponent<T> implements OnInit {
  @Input()
  selectedItemsInput: T[] = []

  @Input()
  options: T[] = []

  @Input({ required: true })
  labelKey!: string

  @Input({ required: true })
  idField!: keyof T

  @Input({ required: true })
  nameField!: keyof T

  @Input()
  displayOption: (value: T) => string = (value: T) => value[this.nameField] as string

  /** The options open in an overlay outside this component, so a class on the host does not reach them. */
  @Input()
  panelClass = ''

  @Output()
  selectionChange = new EventEmitter<T[]>()

  filteredOptions: T[] = []
  selectedItems: T[] = []

  ngOnInit() {
    this.selectedItems = this.selectedItemsInput
  }

  remove(item: T) {
    const index = this.selectedItems.indexOf(item)

    if (index >= 0) {
      this.selectedItems.splice(index, 1)
      this.selectionChange.emit(this.selectedItems)
    }
  }

  filterOutAlreadySelected(data: T[]) {
    return data.filter((item) => !this.selectedItems.map((selectedItem) => selectedItem[this.idField]).includes(item[this.idField]))
  }

  filter(input: HTMLInputElement) {
    const filterValue = input.value.toLowerCase()
    this.filteredOptions = this.filterOutAlreadySelected(this.options).filter((item) =>
      (item[this.nameField] as string).toLowerCase().includes(filterValue.toLowerCase())
    )
  }

  optionSelected($event: MatAutocompleteSelectedEvent, input: HTMLInputElement) {
    this.selectedItems.push($event.option.value)
    this.selectionChange.emit(this.selectedItems)
    input.value = ''
  }
}
